import(/* webpackMode: "eager" */ "/Users/martina/Desktop/Project/cg-templates/cloudflare/next-js-cloudflare/app/global-error.tsx");
